import { CollectionsSlider } from '../utils/sliders-flickity';
import contentFade from '../utils/ContentFadeIn';
import lazyLoad from '../utils/lazyLoad';
import { archiveProductCols } from '../utils/equalCols.js';

const jQ = jQuery.noConflict();
let allowAjax = true;

class TaxonomyAjax {
    constructor(trigger) {
        this.trigger = trigger;
    }
    static termsAjax(term) {
        if (allowAjax) {
            allowAjax = false;
            const formData = new FormData();
            formData.append('action', 'taxonomy_filters');
            formData.append('term', term);

            jQ.ajax({
                type: 'POST',
                url: WP.ajaxUrl,
                contentType: false,
                processData: false,
                data: formData,
                dataType: 'json',
                success: function (response) {
                    allowAjax = true;

                    jQ('.ajax-loading').remove();

                    if (response) {
                        jQ('.taxonomy-page-wrapper .taxonomy-slider').remove();
                        jQ('.taxonomy-page-wrapper').prepend(response[1]);
                        jQ('.taxonomy-page-wrapper .taxonomy-slider').addClass('loading');
                        jQ('.product-cats').html(response[0]);
                        CollectionsSlider.init();
                        setTimeout(() => jQ('.taxonomy-page-wrapper .taxonomy-slider').removeClass('loading'), 600);
                    }
                    jQ('html, body').animate({
                        scrollTop: 0,
                    }, 0);
                    archiveProductCols.init();
                    contentFade.init();
                    lazyLoad();
                },
            });
        }
    }
    static loadFilters(e) {
        e.preventDefault();
        const term = jQ(this).attr('data-term');
        const url = jQ(this).attr('data-url');
        if (allowAjax && !jQ(this).hasClass('active')) {
            if (jQ('.mobile-check').is(':visible')){
                jQ(this).parents('.archive-sidebar').append('<span class="ajax-loading"></span>');
                jQ('.taxonomy-page-wrapper .taxonomy-slider').remove();
            } else {
                jQ(this).parent().parent().append('<span class="ajax-loading"></span>');
            }

            jQ(this).parent().siblings().find('.active').removeClass('active');
            jQ(this).addClass('active');
            history.replaceState(null, null, url);
            TaxonomyAjax.termsAjax(term);
        }
    }
    init() {
        jQ(this.trigger).on('click', TaxonomyAjax.loadFilters);
    }
}
const collectionsAjax = new TaxonomyAjax('.product-term');
export default collectionsAjax;
